import { FileChecksum } from "@rails/activestorage/src/file_checksum";
import { BlobRecord } from "@rails/activestorage/src/blob_record";
import { BlobUpload } from "./blod_upload";

export class DocstoreDirectUpload {
  constructor(file, url, customHeaders = {}) {
    this.file = file;
    this.url = url;
    this.customHeaders = customHeaders;
  }

  create(callback) {
    FileChecksum.create(this.file, (error, checksum) => {
      if (error) {
        callback(error);
        return;
      }

      const blob = new BlobRecord(this.file, checksum, this.url, this.customHeaders);
      blob.create((record_error) => {
        if (record_error) {
          callback(record_error);
        } else {
          const upload = new BlobUpload(blob);
          upload.create((upload_error, response) => {
            if (upload_error) {
              callback(upload_error);
            } else {
              response = {...blob.toJSON(), ...response};
              callback(null, response);
            }
          });
        }
      });
    });
  }
}
